import { useEffect, useState } from "react";

export const useFetchInternalSkusByDistributor = (distributorId) => {
    const [internalSkus, setInternalSkus] = useState(null);

    useEffect(() => {
        const fetchInternalSkus = async () => {
            const rsp = await fetch(`api/internalSku?distributorIds=${distributorId}`);
            const internalSkus = await rsp.json();

            setInternalSkus(internalSkus);
        }
        fetchInternalSkus();
    }, [distributorId])

    return internalSkus;
}

export const PutInternalSku = async (distributorId, itemId, internalSku) => {
    const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(internalSku ?? ""),
    };

    const response = await fetch(`api/internalSku/${distributorId}/${itemId}`, requestOptions);
    if (!response.ok) {
        throw new Error("Failed to save Customer Part #.");
    }
}
